import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";


export default function Sidebar({ isActive, setIsActive, setShow, show }) {
  const dispatch = useDispatch();
  const [showdel, setshowdel] = useState(false);
  const handledelclick = async () => {
    setshowdel(true);
  };
  return (
    <aside>
      <div className="sidebar">
        <div className="toggle-icon" onClick={() => setShow(!show)}>
          <img src={require("../../Assets/Images/toggle.svg").default} />
        </div>
        <div className="logo-side">
          <img
            className="small"
            src={require("../../Assets/Images/C.svg").default}
          />
          <img
            className="big"
            src={require("../../Assets/Images/Logo.svg").default}
          />
        </div>
        <div className="side-menu">
          <div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Dashboard"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Dashboard"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M8.79491 4.39184C8.79491 3.47937 8.79006 2.56621 8.7963 1.65374C8.80324 0.681552 9.48352 0.00726863 10.4547 0.0031021C10.767 0.00171326 11.0815 -0.00939678 11.3918 0.0211577C11.9624 0.0781002 12.5385 0.124627 13.098 0.243373C14.6224 0.566279 15.5061 1.54194 15.7907 3.05439C15.8962 3.61687 15.9538 4.19324 15.9774 4.76544C16.0107 5.56402 15.9989 6.36538 15.9934 7.16535C15.9864 8.11879 15.3131 8.79099 14.3586 8.79585C13.0522 8.8028 11.7465 8.8021 10.4401 8.79585C9.48144 8.79099 8.80394 8.11116 8.797 7.14869C8.79006 6.22997 8.79491 5.31056 8.79491 4.39184Z"
                    fill="#071523"
                  />
                  <path
                    d="M7.20112 11.6152C7.20112 12.5214 7.20528 13.4283 7.19973 14.3345C7.19418 15.3178 6.5139 15.9956 5.53444 15.9984C5.23456 15.9991 4.93398 15.9984 4.6348 15.9838C3.8976 15.9477 3.16457 15.8769 2.4586 15.6408C1.28825 15.2491 0.582287 14.4304 0.272691 13.2506C0.0581952 12.4339 0.00960428 11.5992 0.00405099 10.7604C-0.000113981 10.1291 -0.00150434 9.49791 0.00196647 8.86599C0.0068256 7.87852 0.676001 7.20771 1.6631 7.20424C2.95701 7.20008 4.25024 7.19938 5.54416 7.20424C6.51598 7.20771 7.19279 7.88338 7.19973 8.85766C7.20598 9.77707 7.20112 10.6958 7.20112 11.6152Z"
                    fill="#071523"
                  />
                  <path
                    d="M3.59355 5.59874C2.91258 5.59874 2.23092 5.60777 1.54995 5.59666C0.785675 5.58416 0.135242 5.0314 0.0699904 4.29532C0.0394473 3.95366 0.108176 3.59881 0.163709 3.25508C0.267139 2.62038 0.467747 2.01901 0.853006 1.49264C1.40278 0.741969 2.18302 0.385037 3.06253 0.199627C3.89274 0.0246328 4.73614 -0.00383825 5.58024 0.00449479C6.49515 0.0135223 7.16987 0.662803 7.19486 1.58152C7.21638 2.3933 7.21708 3.20716 7.19486 4.01894C7.16987 4.95016 6.4778 5.59666 5.54346 5.60013C4.89372 5.60221 4.24329 5.60083 3.59355 5.60083C3.59355 5.59944 3.59355 5.59874 3.59355 5.59874Z"
                    fill="#071523"
                  />
                  <path
                    d="M12.3976 10.402C13.0786 10.402 13.7602 10.3937 14.4412 10.4041C15.2152 10.4159 15.8705 10.9763 15.9281 11.7187C15.9545 12.061 15.8879 12.4152 15.8309 12.7589C15.7275 13.3797 15.5304 13.97 15.1576 14.4887C14.6613 15.1797 13.9616 15.5519 13.1577 15.7491C12.1907 15.9866 11.2036 16.0303 10.2159 15.9831C9.44256 15.9463 8.82198 15.2533 8.80185 14.4248C8.78172 13.6124 8.78172 12.7992 8.80116 11.9874C8.82337 11.0597 9.51683 10.4048 10.4484 10.4014C11.0981 10.3986 11.7486 10.4007 12.3983 10.4007C12.3976 10.4014 12.3976 10.402 12.3976 10.402Z"
                    fill="#071523"
                  />
                </svg>
                <p> Dashboard</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                to="/UserManagement"
                className={
                  window.location.pathname == "/UserManagement" ||
                    window.location.pathname == "/WorkersUser" ||
                    window.location.pathname == "/CompanyUser" ||
                    window.location.pathname == "/CustomerProfile/:id"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="20"
                  viewBox="0 0 16 12"
                  fill="none"
                >
                  <path
                    d="M8.00277 12C6.96627 11.9871 5.93168 11.9444 4.93712 11.6477C4.60984 11.5499 4.29971 11.3954 3.99785 11.2398C3.77034 11.1221 3.69599 10.9185 3.73666 10.6738C3.88282 9.79126 3.98069 8.89992 4.17071 8.02556C4.48655 6.57238 5.93867 5.5043 7.5503 5.4885C8.12987 5.48323 8.71199 5.45162 9.28394 5.59091C10.6712 5.92802 11.7052 7.00312 11.9067 8.32462C12.0249 9.103 12.1405 9.88197 12.2689 10.6592C12.3146 10.9337 12.2066 11.1256 11.9696 11.2749C11.5794 11.5201 11.1383 11.6512 10.6852 11.7524C9.80315 11.9491 8.90455 11.9883 8.00277 12Z"
                    fill="#071523"
                  />
                  <path
                    d="M8.00468 5.14027C6.45978 5.14203 5.20975 3.99376 5.20975 2.5716C5.20975 1.15413 6.46931 -0.00408592 8.00659 1.08347e-05C9.54069 0.00410759 10.7901 1.15471 10.7926 2.56517C10.7958 3.98908 9.55149 5.13852 8.00468 5.14027Z"
                    fill="#071523"
                  />
                  <path
                    d="M11.3137 5.85955C12.0776 5.47504 12.865 5.3691 13.681 5.60262C14.9049 5.9526 15.6154 6.73391 15.8506 7.88861C15.8957 8.10925 15.9287 8.33223 15.9802 8.5517C16.038 8.79985 15.9694 9.00351 15.7699 9.17733C15.4216 9.48049 15.0009 9.66836 14.5427 9.75264C14.0438 9.84452 13.5323 9.87905 13.0264 9.94109C12.9082 9.95572 12.898 9.89076 12.8853 9.80824C12.797 9.23645 12.7106 8.66407 12.6121 8.09403C12.471 7.28229 12.0751 6.58643 11.4555 5.9965C11.4116 5.95436 11.3684 5.91222 11.3137 5.85955Z"
                    fill="#071523"
                  />
                  <path
                    d="M4.69182 5.8654C4.05568 6.42197 3.62735 7.07102 3.44814 7.83887C3.33057 8.33984 3.27147 8.85252 3.18758 9.35993C3.16153 9.51854 3.14501 9.67889 3.11006 9.83574C3.10116 9.87612 3.03634 9.93758 2.99884 9.93699C2.20955 9.91944 1.43043 9.84218 0.719938 9.49103C0.523568 9.39388 0.347534 9.25576 0.179126 9.11822C0.0266058 8.99415 -0.0255062 8.82209 0.0113528 8.63481C0.0799869 8.28775 0.131461 7.9366 0.224244 7.59482C0.693244 5.87125 2.79485 4.98752 4.52341 5.77878C4.57425 5.80161 4.62255 5.8297 4.69182 5.8654Z"
                    fill="#071523"
                  />
                  <path
                    d="M3.32231 5.14086C2.28263 5.13793 1.51495 4.63403 1.22961 3.87554C0.944267 3.11706 1.208 2.28424 1.89243 1.78093C2.56289 1.28756 3.50915 1.24016 4.24442 1.65744C4.34483 1.7148 4.38995 1.76747 4.36263 1.88686C4.17388 2.71031 4.30988 3.49279 4.74965 4.22845C4.81129 4.33087 4.80049 4.39466 4.72105 4.47835C4.30607 4.91378 3.7875 5.13618 3.32231 5.14086Z"
                    fill="#071523"
                  />
                  <path
                    d="M12.6851 5.13969C12.1958 5.12915 11.6842 4.90383 11.2762 4.47191C11.2013 4.39232 11.1917 4.33262 11.2495 4.23489C11.6925 3.49454 11.8298 2.70797 11.6391 1.87808C11.6162 1.778 11.6417 1.72123 11.737 1.66915C12.4227 1.294 13.1281 1.25655 13.8252 1.61179C14.5211 1.96646 14.8827 2.5318 14.8808 3.26922C14.8783 4.32443 13.967 5.1432 12.6851 5.13969Z"
                    fill="#071523"
                  />
                </svg>
                <p>User Management</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/WorkersVerification"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/WorkersVerification"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="18"
                  viewBox="0 0 14 16"
                  fill="none"
                >
                  <path
                    d="M14 4.54038C13.9738 7.40799 13.3497 9.90348 11.9 12.0918C10.7215 13.8706 9.19388 15.1296 7.3601 15.9198C7.11692 16.025 6.88435 16.0285 6.64118 15.9198C3.39761 14.4694 1.30756 11.8411 0.380376 8.03787C0.00439173 6.49567 -0.074172 4.92028 0.0630032 3.33006C0.111638 2.76797 0.405318 2.47211 0.934066 2.4368C2.16864 2.35489 3.37329 2.10562 4.52057 1.56472C5.22827 1.23142 5.87985 0.790793 6.47095 0.236476C6.80454 -0.076342 7.18863 -0.0798725 7.52159 0.23224C8.67199 1.31263 10.0076 1.92414 11.4641 2.21436C12.011 2.32311 12.5678 2.37748 13.1215 2.43821C13.6009 2.49117 13.8921 2.78775 13.932 3.32512C13.9663 3.78128 13.9838 4.23956 14 4.54038ZM6.33627 8.70093C6.06691 8.39447 5.82748 8.11978 5.58617 7.84792C5.36732 7.60077 5.09733 7.58171 4.90279 7.79567C4.70825 8.00892 4.72259 8.31962 4.94145 8.56959C5.27067 8.94525 5.60176 9.3188 5.93285 9.69235C6.19785 9.99104 6.43354 9.99245 6.69605 9.69588C7.45425 8.83863 8.21121 7.98067 8.96879 7.12272C9.02054 7.06411 9.07479 7.00691 9.12155 6.94265C9.25124 6.76541 9.26496 6.5345 9.1627 6.34526C9.06107 6.15813 8.86341 6.05363 8.67324 6.12071C8.57347 6.15602 8.4762 6.23369 8.40076 6.31843C7.7473 7.04998 7.09822 7.78649 6.44913 8.52369C6.4086 8.56959 6.38117 8.63031 6.33627 8.70093Z"
                    fill="#071523"
                  />
                </svg>
                <p>Workers Verification</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/CompanyVerification"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/CompanyVerification"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="18"
                  viewBox="0 0 14 16"
                  fill="none"
                >
                  <path
                    d="M14 4.54038C13.9738 7.40799 13.3497 9.90348 11.9 12.0918C10.7215 13.8706 9.19388 15.1296 7.3601 15.9198C7.11692 16.025 6.88435 16.0285 6.64118 15.9198C3.39761 14.4694 1.30756 11.8411 0.380376 8.03787C0.00439173 6.49567 -0.074172 4.92028 0.0630032 3.33006C0.111638 2.76797 0.405318 2.47211 0.934066 2.4368C2.16864 2.35489 3.37329 2.10562 4.52057 1.56472C5.22827 1.23142 5.87985 0.790793 6.47095 0.236476C6.80454 -0.076342 7.18863 -0.0798725 7.52159 0.23224C8.67199 1.31263 10.0076 1.92414 11.4641 2.21436C12.011 2.32311 12.5678 2.37748 13.1215 2.43821C13.6009 2.49117 13.8921 2.78775 13.932 3.32512C13.9663 3.78128 13.9838 4.23956 14 4.54038ZM6.33627 8.70093C6.06691 8.39447 5.82748 8.11978 5.58617 7.84792C5.36732 7.60077 5.09733 7.58171 4.90279 7.79567C4.70825 8.00892 4.72259 8.31962 4.94145 8.56959C5.27067 8.94525 5.60176 9.3188 5.93285 9.69235C6.19785 9.99104 6.43354 9.99245 6.69605 9.69588C7.45425 8.83863 8.21121 7.98067 8.96879 7.12272C9.02054 7.06411 9.07479 7.00691 9.12155 6.94265C9.25124 6.76541 9.26496 6.5345 9.1627 6.34526C9.06107 6.15813 8.86341 6.05363 8.67324 6.12071C8.57347 6.15602 8.4762 6.23369 8.40076 6.31843C7.7473 7.04998 7.09822 7.78649 6.44913 8.52369C6.4086 8.56959 6.38117 8.63031 6.33627 8.70093Z"
                    fill="#071523"
                  />
                </svg>
                <p>Company Verification </p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Payments"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Payments"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M0 12C0 13.105 0.895 14 2 14H14C15.105 14 16 13.105 16 12V7H0V12Z"
                    fill="black"
                  />
                  <path
                    d="M14 2H2C0.895 2 0 2.895 0 4V6H16V4C16 2.895 15.105 2 14 2Z"
                    fill="black"
                  />
                </svg>
                <p>Payments </p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Notification"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Notification"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <path
                    d="M7.76381 17C7.40401 16.9276 7.05312 16.8357 6.7351 16.642C6.36361 16.4157 5.99602 16.0142 5.82559 15.6144C7.27535 15.6144 8.72233 15.6144 10.1827 15.6144C10.0434 15.9375 9.82567 16.2063 9.55387 16.4342C9.19296 16.7372 8.77469 16.9189 8.30127 16.9766C8.28011 16.9793 8.26006 16.9918 8.24001 17C8.08127 17 7.92254 17 7.76381 17Z"
                    fill="#071523"
                  />
                  <path
                    d="M8.00553 14.9545C6.57693 14.9583 5.15167 14.8974 3.73253 14.7391C2.84975 14.6406 1.97421 14.4964 1.11538 14.2652C0.081663 13.9867 -0.335504 12.8671 0.303329 12.0239C0.85639 11.2938 1.39219 10.5561 1.82327 9.7493C2.29892 8.86037 2.65315 7.93336 2.7573 6.92856C2.79573 6.55482 2.7896 6.17618 2.83527 5.80353C2.95836 4.80471 3.37441 3.9272 4.03719 3.16122C4.60752 2.50241 5.30761 2.01715 6.13303 1.70869C6.23328 1.67115 6.26447 1.62273 6.2745 1.51991C6.35192 0.738158 7.02416 0.0924061 7.83732 0.00862701C8.61874 -0.0718879 9.38846 0.418818 9.6402 1.16086C9.67752 1.27021 9.72598 1.385 9.7243 1.49652C9.72208 1.64069 9.80005 1.67931 9.91144 1.72555C11.7232 2.47195 12.7943 3.80371 13.1563 5.68221C13.2075 5.9466 13.2181 6.22133 13.2226 6.49171C13.2387 7.49597 13.5345 8.42951 13.9667 9.32769C14.4139 10.2574 14.9803 11.1159 15.6303 11.9221C15.9823 12.359 16.0998 12.8399 15.9093 13.3681C15.7322 13.8599 15.3579 14.145 14.845 14.2766C13.8464 14.5334 12.8321 14.7059 11.8034 14.7782C10.5391 14.8669 9.27261 14.9284 8.0072 15.0013C8.00664 14.986 8.00608 14.9703 8.00553 14.9545Z"
                    fill="#071523"
                  />
                </svg>
                <p>Notification</p>
              </Link>
            </div>

            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Support"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Support"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="18"
                  viewBox="0 0 13 16"
                  fill="none"
                >
                  <path
                    d="M8.09143 9.42928C8.08613 9.50214 8.08378 9.55394 8.07848 9.60574C8.05081 9.90345 8.14971 10.1551 8.42344 10.2979C8.76368 10.4755 9.1163 10.6343 9.47362 10.7778C10.376 11.1398 11.2667 11.5184 12.0166 12.1457C12.6924 12.7109 12.9073 13.4259 12.7519 14.257C12.683 14.6247 12.4434 14.8894 12.1326 15.0971C11.6299 15.433 11.0565 15.5941 10.4685 15.7102C9.24875 15.9521 8.01137 15.9948 6.77106 15.9988C5.59785 16.0028 4.42405 16.0056 3.2579 15.8514C2.53914 15.7563 1.82863 15.6277 1.16638 15.3254C0.664835 15.0966 0.230401 14.7863 0.0779368 14.2399C-0.110436 13.5659 0.0432044 12.9563 0.532974 12.436C0.929145 12.0147 1.41597 11.7045 1.92929 11.4427C2.61037 11.0954 3.30971 10.7818 4.0008 10.4533C4.13443 10.3896 4.27453 10.3332 4.39697 10.253C4.76253 10.0139 4.87791 9.61257 4.67718 9.23119C4.58063 9.04732 4.44642 8.88054 4.31632 8.71546C3.66644 7.89292 3.19786 6.99182 3.04481 5.95752C2.91883 5.10936 2.93826 4.2686 3.30794 3.46997C3.8136 2.37761 4.70425 1.78503 5.92161 1.63646C6.56149 1.55848 7.19136 1.60003 7.79357 1.83C8.9397 2.26718 9.55014 3.12501 9.77383 4.26291C9.99282 5.37633 9.78384 6.43738 9.29937 7.45574C9.2717 7.51381 9.20106 7.57301 9.13808 7.59122C8.96736 7.64131 8.79018 7.67661 8.61358 7.70336C8.55707 7.7119 8.49349 7.6749 8.43345 7.65839C8.25155 7.60944 8.072 7.53828 7.88716 7.51779C7.66877 7.49331 7.44449 7.50868 7.22315 7.51324C6.66333 7.52462 6.22595 7.94984 6.2289 8.47581C6.23184 8.99666 6.66333 9.41562 7.21373 9.427C7.501 9.43383 7.78709 9.42928 8.09143 9.42928Z"
                    fill="#071523"
                  />
                  <path
                    d="M12.1097 6.39754C12.1097 6.66394 12.1126 6.93034 12.1091 7.19674C12.1002 7.84795 11.4704 8.24129 10.8481 7.99253C10.7905 7.96919 10.6951 7.96919 10.6456 8.0005C9.99988 8.41149 9.27995 8.60104 8.5241 8.69497C8.44581 8.70464 8.37458 8.76384 8.29864 8.798C8.16737 8.8572 8.04022 8.94828 7.90306 8.96535C7.67937 8.99325 7.4492 8.97788 7.22138 8.97161C6.93941 8.96421 6.72985 8.76669 6.71454 8.50598C6.69865 8.23844 6.87407 8.01075 7.15663 7.98627C7.42918 7.96236 7.70645 7.97261 7.98076 7.98456C8.06377 7.98798 8.16796 8.02669 8.22153 8.08475C8.32572 8.19803 8.4358 8.19632 8.57296 8.1781C9.17811 8.09727 9.75206 7.93333 10.276 7.62082C10.3625 7.56902 10.3908 7.52348 10.3696 7.41419C10.3372 7.2457 10.3466 7.06867 10.3454 6.89562C10.3431 6.47268 10.349 6.05031 10.3431 5.62737C10.339 5.30119 10.4626 5.04561 10.7416 4.85605C10.7852 4.82645 10.8134 4.74164 10.8093 4.68528C10.6639 2.81307 9.17222 1.19759 7.26907 0.845799C4.88144 0.404073 2.61803 1.8374 2.07999 4.13256C2.05468 4.23957 2.04231 4.34943 2.01759 4.45645C1.96814 4.66991 1.97344 4.84068 2.20302 4.98413C2.38609 5.09855 2.45555 5.31656 2.45614 5.53572C2.45791 6.10894 2.46497 6.68216 2.45438 7.25537C2.44614 7.71418 2.07292 8.05742 1.59787 8.06596C1.11634 8.07507 0.713106 7.73865 0.698389 7.27758C0.680141 6.69354 0.686615 6.1078 0.6978 5.5232C0.703098 5.24655 0.847912 5.03195 1.07926 4.86573C1.13518 4.82531 1.18522 4.74278 1.18993 4.67618C1.34828 2.40095 3.17196 0.447335 5.49424 0.073348C8.32749 -0.383747 10.9288 1.33762 11.5233 4.06425C11.5445 4.16045 11.5634 4.25722 11.5728 4.35513C11.5969 4.60388 11.604 4.83955 11.8701 5.00633C12.0596 5.12473 12.1079 5.35983 12.1097 5.58183C12.1114 5.85278 12.1097 6.12544 12.1097 6.39754Z"
                    fill="#071523"
                  />
                </svg>
                <p>Support</p>
              </Link>
            </div>


            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/emergency"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/emergency"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#071523"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <p>Emergency Phone Number</p>
              </Link>
            </div>

            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/contact"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/contact"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#071523"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                <p>Contact Detail</p>
              </Link>
            </div>
          </div>
          <div>
            <div className="side-btm-last">
              <div>
                <Link
                  className={
                    window.location.pathname == "/ChangePassword"
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/ChangePassword"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="16"
                    viewBox="0 0 12 16"
                    fill="none"
                  >
                    <path
                      d="M3.40794 4.91251C3.41092 4.90027 3.41212 4.88682 3.41391 4.87397C3.41809 4.83911 3.42286 4.80486 3.42704 4.77C3.41988 4.81587 3.41391 4.86358 3.40794 4.91251ZM1.4265 3.99752C1.4098 4.09538 1.39667 4.19385 1.38653 4.29293C1.40622 4.13574 1.42113 4.03054 1.4265 3.99752Z"
                      fill="#071523"
                    />
                    <path
                      d="M11.9984 7.89785C11.9984 7.78103 11.9882 7.6636 11.9733 7.54861C11.9065 7.03852 11.5216 6.58836 11.0288 6.51925C10.7717 6.48255 10.7269 6.38285 10.7287 6.14371C10.7347 5.28132 10.7675 4.4177 10.5438 3.56754C10.0551 1.7137 8.39049 0.234177 6.53136 0.0274475C4.0565 -0.246561 1.83163 1.56385 1.4271 3.98895C1.4271 3.99079 1.4271 3.99384 1.42591 3.9969C1.42114 4.03054 1.40623 4.13513 1.38594 4.29232C1.3394 4.67214 1.27018 5.35899 1.26899 6.09845C1.26839 6.30334 1.13058 6.48071 0.936669 6.53026C0.31676 6.68867 0.000530346 7.16451 0.000530346 7.94556C0.000530346 10.1425 -0.000662933 12.3407 0.000530346 14.5383C0.00172363 15.4869 0.489185 15.997 1.4098 15.9982C4.46817 16.0013 7.52595 16.0001 10.5831 15.997C10.7568 15.9958 10.9375 15.9829 11.1034 15.9358C11.6804 15.7719 11.9972 15.2851 11.9972 14.5713C12.0013 12.3474 12.0001 10.1223 11.9984 7.89785ZM6.84639 11.4459C6.67038 11.608 6.60892 11.7811 6.61488 12.0123C6.62562 12.4349 6.62383 12.8581 6.61608 13.2808C6.60892 13.7022 6.40069 13.9315 6.03973 13.9346C5.69427 13.9364 5.47172 13.6869 5.46277 13.2777C5.4568 13.0526 5.46157 12.8276 5.46157 12.6025C5.46038 12.4765 5.45262 12.3499 5.46277 12.2245C5.48842 11.8875 5.41803 11.6208 5.16088 11.359C4.71101 10.9022 4.78141 10.1609 5.25394 9.72111C5.72648 9.28135 6.44484 9.31499 6.88755 9.79756C7.31534 10.2642 7.30639 11.0196 6.84639 11.4459ZM8.33201 6.46604C6.78672 6.46726 5.24142 6.46787 3.69613 6.46971C3.48611 6.46971 3.31606 6.29356 3.31964 6.07766C3.32561 5.6697 3.3614 5.2752 3.40376 4.94064C3.40496 4.93147 3.40556 4.92107 3.40794 4.9119C3.41391 4.86297 3.41988 4.81526 3.42704 4.76939C3.42823 4.76143 3.42883 4.75287 3.43003 4.74492C3.45807 4.51067 3.48492 4.2758 3.54637 4.05073C3.55114 4.0336 3.55651 4.01525 3.56248 3.99751C3.56427 3.98956 3.56545 3.98528 3.56545 3.98528C3.89718 2.87824 4.96279 2.08129 6.07611 2.09964C7.26522 2.11799 8.35527 2.95163 8.57722 4.14186C8.69297 4.76021 8.68761 5.40242 8.7085 6.06664C8.71446 6.2856 8.54501 6.46604 8.33201 6.46604Z"
                      fill="#071523"
                    />
                  </svg>
                  <p>Change Password</p>
                </Link>
              </div>
              <div
                onClick={handledelclick}
              >
                <Link
                  className={
                    window.location.pathname == "/"
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                // to="/"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M8.58591 2.1635C8.65716 2.1635 8.71798 2.1635 8.77879 2.1635C9.57858 2.1635 10.3784 2.16228 11.1782 2.16412C11.8735 2.16535 12.2421 2.53464 12.2439 3.22838C12.2446 3.46618 12.2384 3.70398 12.2458 3.94116C12.2587 4.33319 12.5412 4.60356 12.919 4.59434C13.2851 4.58574 13.5579 4.30923 13.5487 3.92088C13.5382 3.47294 13.5585 3.01331 13.467 2.58011C13.2593 1.60065 12.3588 0.893399 11.3538 0.879266C10.3544 0.865133 9.35437 0.872507 8.35432 0.876808C8.22655 0.877422 8.1295 0.849771 8.04166 0.752685C7.30514 -0.0651715 6.40276 -0.159185 5.42544 0.196592C4.06604 0.690624 2.70849 1.19264 1.36322 1.72539C0.543154 2.05044 0.102102 2.70424 0.01856 3.57862C-0.0158396 3.93809 0.00811726 4.30308 0.00811726 4.66562C0.00750299 7.12902 0.0234742 9.59181 0.000745919 12.0552C-0.00908254 13.1318 0.645739 14.0258 1.58374 14.3582C2.89461 14.8234 4.19259 15.3236 5.48933 15.8268C6.20619 16.1052 6.8862 16.0437 7.54102 15.6732C7.7382 15.5614 7.90959 15.3961 8.07237 15.2345C8.15714 15.1509 8.23393 15.1202 8.34695 15.1202C9.30277 15.1232 10.2592 15.1263 11.215 15.1208C12.2814 15.114 13.1623 14.4781 13.4553 13.5103C13.6126 12.9904 13.5671 12.4552 13.5345 11.9274C13.5137 11.5888 13.1912 11.3719 12.8521 11.3947C12.4835 11.4192 12.2648 11.6325 12.2482 12.0054C12.2366 12.274 12.2464 12.5431 12.2439 12.8116C12.239 13.3972 11.8238 13.8193 11.2427 13.8218C10.3618 13.8255 9.48153 13.823 8.58591 13.823C8.58591 9.94083 8.58591 6.06845 8.58591 2.1635Z"
                      fill="#071523"
                    />
                    <path
                      d="M13.8423 8.68854C13.6592 8.86735 13.47 9.04063 13.2956 9.22681C13.0652 9.47322 13.0738 9.86648 13.3017 10.0926C13.5321 10.3206 13.8939 10.3243 14.1439 10.0772C14.7207 9.50701 15.292 8.93064 15.8571 8.34874C16.0832 8.11586 16.034 7.84303 15.7588 7.66422C15.7128 7.63411 15.6741 7.5911 15.6348 7.55116C15.1384 7.05836 14.6427 6.56494 14.1451 6.07336C13.9443 5.87428 13.7047 5.81406 13.4399 5.91667C13.2053 6.00823 13.072 6.1895 13.048 6.44266C13.0278 6.65649 13.1101 6.831 13.2606 6.9797C13.4277 7.14438 13.5904 7.31336 13.7876 7.51368C13.6795 7.51368 13.6138 7.51368 13.5481 7.51368C12.524 7.51368 11.5 7.51122 10.4767 7.51491C10.062 7.51675 9.79051 7.78957 9.80095 8.17607C9.80709 8.40404 9.91951 8.55397 10.1449 8.60374C10.2715 8.63139 10.4042 8.64184 10.5344 8.64246C11.5645 8.64553 12.5947 8.6443 13.6248 8.6443C13.6912 8.6443 13.7581 8.6443 13.8245 8.6443C13.8306 8.65905 13.8361 8.67379 13.8423 8.68854Z"
                      fill="#071523"
                    />
                  </svg>
                  <p>Logout</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showdel} className="delete-popup">
        <Modal.Body>
          <h2 className="are-sure-text">
            Are you sure you want to logout?
          </h2>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-none">
          <Button
            className="theme-btn"
            onClick={() => {
              window.location.href = "/";
              sessionStorage.clear();
            }}
          >
            Yes
          </Button>
          <Button className="theme-btn" onClick={() => setshowdel(false)}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </aside>
  );
}
